// One duration for the CSS collapse and the timer that hides the row once it has played.
export const ROW_EXIT_MS = 220;
export const ROW_EXIT_TRANSITION = 'duration-[220ms] ease-out motion-reduce:transition-none';

export function prefersReducedMotion(): boolean {
    return globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
}
